module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Regular.da586e1.eot";